import { css, styled } from '@creditas/stylitas';

const styles = css({
  '& .message': {
    width: '90%',
    minWidth: 300,
    maxWidth: 500,
    position: 'fixed',
    top: '-20px',
    left: '50%',
    transform: 'translate(-50%, 0px)',
    zIndex: 20,
    transition: 'top 0.4s ease-in, opacity 0.4s ease-out, visibility 0.5s',
    visibility: 'hidden',
    opacity: 0,
    '&-active': {
      top: '20px',
      opacity: 1,
      visibility: 'visible',
    },
  },
});

export default styled.div`
  ${styles}
`;
